import { IProps } from '@/Interfaces/Icons/Props.interface';
import classNames from 'classnames';

const CreativeLibraryIcon = ({ className, ...props }: IProps) => {
  const iconClassName = classNames('creative-library-icon', className);

  return (
    <svg
      className={iconClassName}
      xmlns='http://www.w3.org/2000/svg'
      width='24'
      height='24'
      fill='none'
      viewBox='0 0 24 24'
      {...props}
    >
      <g>
        <g fill='currentColor'>
          <g>
            <path d='M15.25 14.438c0-1.507 1.254-2.688 2.75-2.688 1.497 0 2.75 1.181 2.75 2.688 0 1.506-1.253 2.688-2.75 2.688-1.496 0-2.75-1.182-2.75-2.688zM15.088 18.386c1.692-.878 4.133-.878 5.824 0 .31.151.86.42 1.234.74.227.194.536.522.595.99.067.533-.216.961-.578 1.262-.568.471-1.279.872-2.203.872h-3.92c-.924 0-1.635-.4-2.202-.872-.362-.3-.645-.729-.578-1.262.059-.468.368-.796.595-.99.374-.32.924-.589 1.233-.74z'></path>
          </g>
          <path d='M9.463 1.989c-.64-.24-1.35-.24-2.38-.239-.88 0-1.761 0-2.333.05-.59.052-1.106.162-1.577.425a3.75 3.75 0 00-1.448 1.448c-.263.471-.373.987-.425 1.577-.05.572-.05 1.28-.05 2.16v3.147c0 2.309 0 4.118.19 5.53.194 1.444.6 2.584 1.494 3.479.895.895 2.035 1.3 3.48 1.494 1.225.165 2.749.187 4.64.19.365 0 .548 0 .637-.092.089-.092.08-.316.06-.763-.006-.15 0-.304.02-.465.13-1.035.796-1.677 1.11-1.944.294-.252.708-.501 1.066-.697.292-.16.437-.239.473-.356.036-.117-.047-.277-.213-.598a4.115 4.115 0 01-.457-1.897c0-2.383 1.974-4.188 4.25-4.188 2.198 0 4.115 1.683 4.243 3.945a.254.254 0 00.25.243.241.241 0 00.241-.236c.016-.71.016-1.51.016-2.41 0-1.019 0-1.923-.067-2.582-.07-.681-.216-1.271-.565-1.793a3.75 3.75 0 00-1.035-1.035c-.522-.349-1.112-.496-1.792-.565-.66-.067-1.482-.067-2.5-.067h-3.555c-.316 0-.496 0-.63-.015a.262.262 0 01-.193-.12 20.977 20.977 0 01-.47-.909c-.473-.955-1.085-2.194-2.48-2.717z'></path>
        </g>
      </g>
    </svg>
  );
};

export default CreativeLibraryIcon;
